"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redefinePublicPath = void 0;
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const redefinePublicPath = () => {
  // We don't support setting public path in webpack via NPM build.
};
exports.redefinePublicPath = redefinePublicPath;